import React, { createContext, useContext } from 'react';

const HomeDataContext = createContext({
  data: null,
  isLoading: false,
  error: null,
  isUsingFallback: false
});

export function HomeDataProvider({ value, children }) {
  return (
    <HomeDataContext.Provider value={value}>
      {children}
    </HomeDataContext.Provider>
  );
}

export function useHomeDataContext() {
  return useContext(HomeDataContext);
}

export default HomeDataContext;

